enum LinkTarget {
  BLANK = '_blank',
  SELF = '_self',
  PARENT = '_parent',
  TOP = '_top',
  FRAMENAME = 'framename',
}
enum Theme {
  PURPLE = 'theme-purple',
  BLUE = 'theme-blue',
  ORANGE = 'theme-orange',
  GREEN = 'theme-green',
  RED = 'theme-red',
  YELLOW = 'theme-yellow',
  SUCCESS = 'theme-success',
  ERROR = 'theme-error',
  WARNING = 'theme-warning',
  ACTION = 'theme-action',
  GRAY = 'theme-gray',
  BLACK = 'theme-black',
  WHITE = 'theme-white',
  PINK = 'theme-pink',
}
enum MLPVersion {
  ONE = 'one',
  TWO = 'two',
  THREE = 'three',
}
enum EVENT_KEY {
  ENTER = 'Enter',
  ARROW_UP = 'ArrowUp',
  ARROW_DOWN = 'ArrowDown',
  PAGE_UP = 'PageUp',
  PAGE_DOWN = 'PageDown',
  HOME = 'Home',
  END = 'End',
  SPACE = ' ',
}
enum IconAnimationClassName {
  BEAT = 'fa-beat',
  BREAT_FADE = 'fa-beat-fade',
  BOUNCE = 'fa-bounce',
  FADE = 'fa-fade',
  FLIP = 'fa-flip',
  SHAKE = 'fa-shake',
  SPIN = 'fa-spin',
  SPIN_REVERSE = 'fa-spin fa-spin-reverse',
  SPIN_PULSE = 'fa-spinner-third fa-spin-pulse',
}

// |0----xs----375----sm----768----md----1024----lg----1440----xl----1920|
enum ViewPortSizes {
  SMALL = 375,
  MEDIUM = 768,
  LARGE = 1024,
  XLARGE = 1440,
}

enum Breakpoints {
  XS = 'xs', //small mobile
  SM = 'sm', //mobile
  MD = 'md', //tablet
  LG = 'lg', //desktop
  XL = 'xl', //large desktop
}

const DEFAULT_PORTAL_CONTAINER_ID = 'default-portal-container';

enum Position {
  CENTER = 'center',
  RIGHT = 'end',
}

enum KeyConstants {
  ENTER = 'Enter',
  SPACE = 'Space',
  ARROW_UP = 'ArrowUp',
  ARROW_DOWN = 'ArrowDown',
  ESCAPE = 'Escape',
}

export {
  LinkTarget,
  Theme,
  MLPVersion,
  EVENT_KEY,
  IconAnimationClassName,
  ViewPortSizes,
  Breakpoints,
  DEFAULT_PORTAL_CONTAINER_ID,
  Position,
  KeyConstants,
};
